<script>
import AppleStoreBadge from '@/components/svg/app-store-badges/Apple'
import AndroidStoreBadge from '@/components/svg/app-store-badges/Android'
import FadeSlideUp from '@/components/transitions/FadeSlideUp'
import { iosStoreUrl, androidStoreUrl } from '@/constants/app'

export default {
  components: { AppleStoreBadge, AndroidStoreBadge, FadeSlideUp },
  data() {
    return {
      iosStoreUrl,
      androidStoreUrl,
    }
  },
}
</script>

<template>
	<FadeSlideUp>
		<div class="py-12 px-6 flex justify-center items-center gap-3 flex-wrap">
			<a :href="iosStoreUrl" target="_blank">
				<AppleStoreBadge class="h-10" />
			</a>
			<a :href="androidStoreUrl" target="_blank">
				<AndroidStoreBadge class="h-10" />
			</a>
		</div>
	</FadeSlideUp>
</template>
